import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, defer } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpProgressService } from '../services/http-progress.service';

@Injectable()
export class HttpProgressInterceptor implements HttpInterceptor {
  constructor(private progressService: HttpProgressService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Count on subscription: other interceptors (e.g. Auth0) may call next.handle() without subscribing
    return defer(() => {
      this.progressService.increment();
      return next.handle(req).pipe(
        finalize(() => this.progressService.decrement())
      );
    });
  }
}
